import { Component } from '@verndale/core';

class ShareModule extends Component {
  url: string;

  constructor(el: HTMLElement) {
    super(el);
    this.url = window.location.href;
  }

  setupDefaults() {
    this.dom = {
      svgIcons: this.el.querySelectorAll<HTMLElement>('.share-module__icon-button svg'),
      options: this.el.querySelectorAll<HTMLElement>('[data-service]')
    };
  }

  addListeners() {
    (this.dom.options as NodeListOf<HTMLButtonElement>).forEach(option => {
      option.addEventListener('click', this.handleOptionClick.bind(this));
    });
  }

  handleOptionClick(e: Event) {
    const target = e.currentTarget as HTMLElement;
    const service = target.dataset.service;

    if (service) {
      this.share(service);
    }
  }

  share(service: string) {
    switch (service) {
      case 'facebook':
        this.openModal(`https://www.facebook.com/share.php?u=${this.url}`);
        break;
      case 'x':
        this.openModal(`https://twitter.com/share?url=${this.url}`);
        break;
      case 'linkedin':
        this.openModal(`https://www.linkedin.com/sharing/share-offsite/?url=${this.url}`);
        break;
      case 'mail':
        this.openModal(`mailto:?body=${window.location.href}`);
        break;
      case 'email':
        this.openModal(`mailto:?body=${window.location.href}`);
        break;
      default:
        break;
    }
  }

  openModal(url: string) {
    const winTop = window.innerHeight / 3 - 200;
    const winLeft = window.innerWidth / 2 - 300;

    window.open(
      url,
      'sharer',
      `top=${winTop}, left=${winLeft}, width=600, height=400, scrollbars=no`
    );
  }
}

export default ShareModule;
